import { UserLevel, type MyMesttiOpsAccess, type UserAccess } from '../../../types/access';

export const isActiveUserAccess = (access: UserAccess, nowMs = Date.now()): boolean => {
  if (!access.is_active) return false;
  if (!access.expires_at) return true;
  const expiresAtMs = Date.parse(access.expires_at);
  return Number.isFinite(expiresAtMs) && expiresAtMs > nowMs;
};

/**
 * Pode abrir o Mestti OPS?
 *
 * Quem decide é o backend (`GET /users/me/mestti-ops-access`, regra única em
 * `app/core/mestti_ops_access.py`: padrão do nível + override individual). O
 * frontend só renderiza: sem resposta (carregando, erro de rede) = fechado.
 */
export const canAccessMesttiOps = (
  access: Pick<MyMesttiOpsAccess, 'enabled'> | null | undefined,
): boolean => access?.enabled === true;

/**
 * Pode liberar/retirar uma Ordem de Produção da programação?
 *
 * Espelha **exatamente** a autorização do backend, que para estas ações é por
 * PAPEL (`user_level` -> matriz do `rbac_manager`): SUPER_ADMIN, ADMIN e MANAGER
 * podem; USER e VIEWER não.
 *
 * Estritamente por papel, de propósito — sem `|| hasPermission(...)`:
 *
 * - `production_planning_edit` não existe no `AccessType` do backend e nunca é
 *   concedido em `user_accesses` (`ROLE_BASE_PERMISSIONS` só dá os `*_view` e os
 *   `sidebar_*`), então checar a permissão sozinha esconderia a feature de todos;
 * - e aceitar a permissão como alternativa seria uma promessa que só vale de um
 *   lado: se a concessão granular passasse a existir para um USER, o botão
 *   apareceria e o backend devolveria 403 pela matriz de papéis.
 *
 * Quando o backend suportar grant granular de verdade, as duas pontas mudam juntas.
 */
export const canReleaseProductionOrder = (
  userLevel: UserLevel | string | null | undefined,
): boolean =>
  userLevel === UserLevel.SUPER_ADMIN ||
  userLevel === UserLevel.ADMIN ||
  userLevel === UserLevel.MANAGER;
